'use client'

import { useContext, useEffect } from 'react'

import BrazeContext from './BrazeContext'

type Props = {
  userExternalId: string | null
}

export const BrazeExternalIdSetter = ({ userExternalId }: Props) => {
  const brazeContext = useContext(BrazeContext)

  useEffect(() => {
    if (userExternalId) brazeContext.setUserExternalId(userExternalId)
  }, [brazeContext, userExternalId])

  return null
}
